import * as React from 'react';

import { WrappedFC } from '../shared/types';

interface Props {
  type: 'item';
  subType?: 'country full' | 'language full' | 'canonId';
  /** クリック時のCallback */
  onClick?: (e: React.MouseEvent) => void;
}

const DEFAULT_COMPONENT: keyof JSX.IntrinsicElements = 'div';

/**
 * ボタンコンポーネント
 */
export const Column: WrappedFC<typeof DEFAULT_COMPONENT, Props> = ({
  type,
  subType = 'default',
  className,
  element: Element = DEFAULT_COMPONENT,
  ...props
}) => {
  const _type = subType === 'default' ? type : `${type} ${subType}`;
  const _clsName = className || _type;
  return (
    <Element {...props} className={_clsName}>
      {props.children}
    </Element>
  );
};
Column.displayName = 'Column';
